import React, { useState } from "react";
import {
  Avatar,
  Box,
  Modal,
  Paper,
  Tooltip,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  Table,

} from "@mui/material";
import BookingStatus from "./BookingStatus.jsx";

function getInitials(user) {
  if (!user) return "?";
  const { vorname = "", nachname = "" } = user;
  return `${vorname[0] || ""}${nachname[0] || ""}`.toUpperCase();
}

const formatDateTime = (
  dateString,
  options = {
    time: true,
  }
) => {
  if (!dateString) return;

  const defaultOptions = {
    dateStyle: "short",
    timeStyle: options.time ? "short" : undefined,
  };

  const mergedOptions = {
    ...defaultOptions,
    ...options,
  };

  const date = new Date(dateString);
  const dateStr = new Intl.DateTimeFormat("de-DE", mergedOptions)?.format(date);

  if (mergedOptions.timeStyle) {
    return `${dateStr} Uhr`;
  }

  return dateStr;
};

export default function BookingUserLog({ booking }) {
  const [open, setOpen] = useState(false);

  if (!booking) return null;

  const log = [
    {
      label: "Erstellt am",
      status: "pending",
      value: booking.created_at,
      user: booking.createdBy,
    },
    {
      label: "Freigegeben am",
      status: "released",
      value: booking.released_at,
      user: booking.releasedBy,
    },
    {
      label: "Exportiert am",
      status: "exported",
      value: booking.exported_at,
      user: booking.exportedBy,
    },
    {
      label: "Abgeschlossen am",
      status: "finished",
      value: booking.finished_at,
      user: booking.finishedBy,
    },
  ];

  let user, label;
  switch (booking.status) {
    case "pending":
      user = booking.createdBy;
      label = "Erstellt von";
      break;
    case "released":
      user = booking.releasedBy;
      label = "Freigegeben von";
      break;
    case "exported":
      user = booking.exportedBy;
      label = "Exportiert von";
      break;
    case "finished":
      user = booking.finishedBy;
      label = "Abgeschlossen von";
      break;
    default:
      user = null;
      label = "";
  }

  if (!user) return null;

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Box display="flex" alignItems="center" gap={1}>
        <Tooltip title={`${label} ${user.vorname} ${user.nachname}`}>
          <Avatar
            sx={{ width: 32, height: 32, fontSize: 16, cursor: "pointer" }}
            onClick={handleOpen}
          >
            {getInitials(user)}
          </Avatar>
        </Tooltip>
      </Box>

      <Modal open={open} onClose={handleClose}>
        <Paper
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            padding: 4,
            width: 600,
          }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Status</TableCell>
                <TableCell>Datum</TableCell>
                <TableCell>Benutzer</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {log.map((entry, index) => (
                <TableRow
                  key={index}
                  sx={{
                    opacity: entry.value ? 1 : 0.3,
                  }}
                >
                  <TableCell>
                    <BookingStatus
                      booking={{ status: entry.status }}
                      showLabel={true}
                    />
                  </TableCell>
                  <TableCell>
                    {formatDateTime(entry.value, { time: true })}
                  </TableCell>

                  <TableCell>
                    <Box display="flex" alignItems="center" gap={1}>
                      <Avatar sx={{ width: 24, height: 24, fontSize: 14 }}>
                        {getInitials(entry.user)}
                      </Avatar>
                      {entry.user?.vorname} {entry.user?.nachname}
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      </Modal>
    </>
  );
}
